import React, { ReactNode } from "react";

interface SecondaryWidthWrapperProps {
  children: ReactNode;
}

const SecondaryWidthWrapper: React.FC<SecondaryWidthWrapperProps> = ({
  children,
}) => {
  return <div className={"m-auto w-[90%]"}>{children}</div>;
};
export default SecondaryWidthWrapper;
